import React, { useState } from "react";
import OvertimeTable from "./components/OvertimeTable";
import OvertimeForm from "./components/OvertimeForm";
import PopupButton from "components/button/PopupButton";
import { MODULE_OVERTIME, DATE_FORMAT } from "variables/constants";
import SummaryHeader from "components/header/SummaryHeader";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const Overtimes = () => {
	const [dateRange, setDateRange] = useState(null);
    
	return (
	    <div>
			<SummaryHeader
				title="Overtime History"
				iconName="ClipboardList"
				description="View your past and pending overtime requests"
				color={"cyan"}
				rightNav={
						<PopupButton 
							id="add_overtime" 
							title="Request Overtime"
							description="Submit a new overtime request"
							label="File Overtime" 
							btnClass="btn-overtime" 
							action="add"
							moduleId={MODULE_OVERTIME}
							iconName="FilePlusCorner"
							useCustomClass={true}

						>
							<OvertimeForm recordId="0" mode="edit"/>
						</PopupButton>
				}
			>
			</SummaryHeader>
			<div className="mt-5 w-full md:w-1/2 max-w-[350px]">
				<RangePicker
					format={DATE_FORMAT}
					onChange={(dates) => setDateRange(dates)}
					className="input-field"
					allowClear
				/>
			</div>
			<div className="p-4 border rounded-2xl mt-5">      		
				<OvertimeTable dateRange={dateRange}/>
			</div>
	    </div>
    );
};

export default Overtimes;